var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M52.858 71.039H41.847c-7.505 0-13.589-6.03-13.589-13.468V29.558h38.19v22.665M27.95 57.57h-6.079c-2.138 0-3.872-1.528-3.872-3.413V40.786c0-1.885 1.734-3.412 3.872-3.412h6.08m.306-.016h38.19M36.454 11s-4.362 3.52 0 6.21c4.361 2.692-1.558 5.798-1.558 5.798M48.447 11s-4.361 3.52 0 6.21c4.36 2.692-1.557 5.798-1.557 5.798M60.44 11s-4.362 3.52 0 6.21c4.361 2.692-1.558 5.798-1.558 5.798M82 66.673C82 74.585 75.53 81 67.548 81c-7.981 0-14.451-6.415-14.451-14.327 0-7.913 6.47-14.328 14.451-14.328C75.53 52.345 82 58.76 82 66.673h0zM67.05 60.93v6.54l3.912 3.954"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.297,
    cy: 85.297,
    r: 3,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 3.297 85.297)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.198,
    cy: 2.198,
    r: 2,
    fill: "#0046AA",
    fillRule: "nonzero",
    transform: "rotate(-174 88.198 2.198)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF94CA",
    d: "M69.27 5.016C70.884 3.344 72.5 1.672 74.076 0L89 13.68C87.27 15.466 83.73 19 83.73 19c-4.807-4.522-9.615-9.082-14.422-13.604 0 0-.231-.228-.039-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M81.654 13.3c.077 1.71 2.808 1.596 2.73-.114-.076-1.748-2.807-1.634-2.73.114zM77.5 9.386c-.077-1.71 2.654-1.862 2.73-.114.04 1.71-2.653 1.862-2.73.114zm-3.577-3.23c-.077-1.71 2.654-1.862 2.73-.114.078 1.748-2.653 1.862-2.73.114z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.00a011f4.svg";
export { ForwardRef as ReactComponent };